import React from 'react';
import { Box } from '@material-ui/core';
import { SnackbarProvider } from 'notistack';

import useStyles from './styles';

const ContainerApp = props => {
  const classes = useStyles();
  const { children } = props;

  return (
    <SnackbarProvider
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      classes={{ root: classes.appSnackbar }}
      autoHideDuration={2000}
    >
      <Box className={classes.container}>{children}</Box>
    </SnackbarProvider>
  );
};

export default ContainerApp;
